import { Account } from "./account";
import { Horse } from "./horse";
import { Livestock } from "./livestock";

export class Winner {
    id: number;
    name: string;
    number: string;
    place: number;
    payout: number;

    isAggregate: boolean;
    isAverage: boolean;
    isFastTime: boolean;
    onXRounds: number;
    round: number;
    rotation: number;

    payoutConfigId: number;
    rodeoEventId: number;
    scheduleId: number;
    sidepotId: number;

    contestantOne: Account;
    contestantOneId: number;
    contestantTwo: Account;
    contestantTwoId: number;

    isExtraRunForContestantOne: boolean;
    isExtraRunForContestantTwo: boolean;

    payRiderOne: boolean;
    payRiderTwo: boolean;

    horseOne: Horse;
    horseOneId: number;
    horseTwo: Horse;
    horseTwoId: number;

    livestock: Livestock;
    livestockId: number;

    time: number;
    score: number;

    updated: string;
    edited: boolean;
}


// WEBPACK FOOTER //
// ./src/model/winner.ts